import { useState } from "react";
import { infoUpdateType } from "types/notifications";
import { useInfoUpdateEvent } from "./useInfoUpdateEvent";

type Params = {
  callback: (data: infoUpdateType) => void
}

const infoDocumentUpdateKindList = [
  "createOrderFileData",
  "deleteOrderFileData",
  "createOrderFile",
  "deleteOrderFile",
  "updateOrderFileData",
  "updateOrderFile",
  "workerDocumentGenerator"
];

export const useDocumentUpdateSocketEvent = ({ callback }: Params) => {
  const [time, setTime] = useState<string|null>(null);

  useInfoUpdateEvent((data: infoUpdateType) => {
    const actualDate = new Date();
    setTime(actualDate.getTime().toString());
    callback(data);
  }, (data) => infoDocumentUpdateKindList.some((kind) => kind === data.kind));
  return {
    time
  };
};
